// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2Gmpk","title":"AfterBackImages_title__1vhKO","images":"AfterBackImages_images__BfDlE"};